import { getClockInWarningDistanceMt, getGeoRefDistanceMt, getShowDistantClockInWarning, getShowDistantClockInWarningOnAnyClockIn } from '@/utils/api/config'

const asin = Math.asin
const cos = Math.cos
const sin = Math.sin
const sqrt = Math.sqrt
const PI = Math.PI

// equatorial mean radius of Earth (in meters)
const R = 6378137

function squared (x) { 
  return x * x 
}

function toRad (x) { 
  return x * PI / 180.0 
}

function hav (x) { 
  return squared(sin(x / 2)) 
}

function haversineDistance (a, b) {
  const aLat = toRad(a.lat)
  const bLat = toRad(b.lat)
  const aLng = toRad(a.lng)
  const bLng = toRad(b.lng)

  const ht = hav(bLat - aLat) + cos(aLat) * cos(bLat) * hav(bLng - aLng)
  return 2 * R * asin(sqrt(ht))
}

// 0: no range -> default
// 1: inside range
// -1: outside range
function getRangeCode(clockIn) {
  if (clockIn && clockIn.project) {
    let project = clockIn.project

    // if showDistantClockInWarningOnAnyClockIn is enabled it takes precedence over showDistantClockInWarning
    if (((getShowDistantClockInWarningOnAnyClockIn() && getClockInWarningDistanceMt()) || (getShowDistantClockInWarning() && getGeoRefDistanceMt()))
      && project.latitude
      && project.longitude
      && clockIn.geolocation
    ) {
      let geolocation = JSON.parse(clockIn.geolocation)
      return haversineDistance(
        {lat: project.latitude, lng: project.longitude},
        {lat: geolocation.latitude, lng: geolocation.longitude}
      ) <= (getShowDistantClockInWarningOnAnyClockIn() ? getClockInWarningDistanceMt() : getGeoRefDistanceMt()) ? 1 : -1
    }
  }
  return 0
}

export default getRangeCode
